import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-047d7d0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "inner"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["poster"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["poster"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = ["poster"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["poster"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
import { nextTick, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'grid',
    props: ['d'],
    setup(__props) {
        const grid = ref(null);
        const bottomPadding = ref(100);
        nextTick(() => {
            if (grid.value && grid.value.nextElementSibling) {
                if (!grid.value.classList.contains('top_spacing-')) {
                    if (grid.value.nextElementSibling.classList.contains('grid') || grid.value.nextElementSibling.classList.contains('images')) {
                        bottomPadding.value = 0;
                    }
                    if (grid.value.nextElementSibling.classList.contains('default')) {
                        bottomPadding.value = 25;
                    }
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "grid",
                ref: grid,
                class: _normalizeClass(["mod mod_grid", ['mod_' + __props.d.type + ` bottom_spacing-` + bottomPadding.value, { 'container': __props.d.type === 'grid--frame' }]])
            }, [
                (__props.d.type == 'grid--inset')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["inner grid", __props.d.type])
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.grid_items, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: _normalizeClass(["grid__item", 'colspan' + item.colspan + ' rowspan' + item.rowspan])
                                }, [
                                    (item.image)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: item.image,
                                            alt: item.image_alt_tag,
                                            style: { "width": "100%", "display": "flex" },
                                            loading: "lazy"
                                        }, null, 8, _hoisted_2))
                                        : _createCommentVNode("", true),
                                    (item.video_mp4 && item.video_autoplay !== '1')
                                        ? (_openBlock(), _createElementBlock("video", {
                                            key: 1,
                                            playsinline: "",
                                            poster: item.video_poster
                                        }, [
                                            _createElementVNode("source", {
                                                src: item.video_mp4,
                                                type: "video/mp4"
                                            }, null, 8, _hoisted_4),
                                            (item.video_webm)
                                                ? (_openBlock(), _createElementBlock("source", {
                                                    key: 0,
                                                    src: item.video_webm,
                                                    type: "video/webm"
                                                }, null, 8, _hoisted_5))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" Your browser does not support this video. ")
                                        ], 8, _hoisted_3))
                                        : _createCommentVNode("", true),
                                    (item.video_mp4 && item.video_autoplay == '1')
                                        ? (_openBlock(), _createElementBlock("video", {
                                            key: 2,
                                            autoplay: "",
                                            playsinline: "",
                                            poster: item.video_poster
                                        }, [
                                            _createElementVNode("source", {
                                                src: item.video_mp4,
                                                type: "video/mp4"
                                            }, null, 8, _hoisted_7),
                                            (item.video_webm)
                                                ? (_openBlock(), _createElementBlock("source", {
                                                    key: 0,
                                                    src: item.video_webm,
                                                    type: "video/webm"
                                                }, null, 8, _hoisted_8))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" Your browser does not support this video. ")
                                        ], 8, _hoisted_6))
                                        : _createCommentVNode("", true)
                                ], 2));
                            }), 128))
                        ], 2)
                    ]))
                    : _createCommentVNode("", true),
                (__props.d.type !== 'grid--inset')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["grid", __props.d.type])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.grid_items, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(["grid__item", 'colspan' + item.colspan + ' rowspan' + item.rowspan])
                            }, [
                                (item.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: item.image,
                                        alt: item.image_alt_tag,
                                        style: { "width": "100%", "display": "flex" },
                                        loading: "lazy"
                                    }, null, 8, _hoisted_9))
                                    : _createCommentVNode("", true),
                                (item.video_mp4 && item.video_autoplay !== '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 1,
                                        playsinline: "",
                                        poster: item.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: item.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_11),
                                        (item.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: item.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_12))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_10))
                                    : _createCommentVNode("", true),
                                (item.video_mp4 && item.video_autoplay == '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 2,
                                        autoplay: "",
                                        playsinline: "",
                                        poster: item.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: item.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_14),
                                        (item.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: item.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_15))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_13))
                                    : _createCommentVNode("", true)
                            ], 2));
                        }), 128))
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
